import FormUnsettledEditor from '.';
import DesignTool from "./DesignTool";

/** @type {UICore.ComponentMeta} */
const FormUnsettledEditorComponentMeta = {
  id: 'w-form-unsettled-editor',
  bindings: [{
    id: '数据源',
    pathProp: 'dataPath',
    required: true,
    main: true
  }],
  propsSchema: {
    type: 'object',
    fields: [{
      id: 'dataPath',
      type: 'string',
      readonly: true
    }]
  },
  designTool: DesignTool,
  component: FormUnsettledEditor,
  fitData: () => null // 这不是一个备选组件！
};
export default FormUnsettledEditorComponentMeta;
//# sourceMappingURL=meta.js.map
